module.exports = __webpack_public_path__ + "img/dicoding-2.968ebe67.png";